<template>
  <div id="app">
    <!-- PAGE #page -->
    <div id="page" class="hfeed site">
      <!-- <appHeader></appHeader> -->
      <!-- HEADER TITLE BREADCRUBS SECTION -->
      <!-- Page content -->
      <div id="primary" class="no-padding content-area no-sidebar">
        <router-view />
      </div>

      <!-- BACK TO TOP BUTTON -->
      <a class="back-to-top" href="#">
        <i class="fa fa-long-arrow-up" aria-hidden="true"></i>
      </a>

      <!-- FOOTER -->
      <!-- <appFooter></appFooter> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import appFooter from "./components/common/footer";
import appHeader from "./components/common/header";

export default {
  name: "App",
  components: {
    appHeader,
    appFooter
  }
};
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue